import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const MODEL_GENERATION_UPDATE_RESOURCE = "model-generation" as const;
export const MODEL_GENERATION_UPDATE_API_PATH = `/v1/${MODEL_GENERATION_UPDATE_RESOURCE}/{uuid}` as const;

export type ModelGenerationUpdateBody =
  paths[typeof MODEL_GENERATION_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type ModelGenerationUpdateInput = ModelGenerationUpdateBody & {
  uuid: string;
};
export type ModelGenerationUpdateResponse =
  paths[typeof MODEL_GENERATION_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useModelGenerationUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ModelGenerationUpdateResponse, Error, ModelGenerationUpdateInput>({
    mutationFn: async (data: ModelGenerationUpdateInput) => {
      const { uuid, ...rest } = data;
      const response = await alphartisApiAxios.patch<ModelGenerationUpdateResponse>(
        `/v1/${MODEL_GENERATION_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MODEL_GENERATION_UPDATE_RESOURCE],
      });
    },
  });
};
